module.exports={
    btn:{
        tips_reelect_btn:"Uusi kuva",
        cancel_btn:"Peruuttaa",
        tips_continue_dispose:"Laadukkaat tuetut kuvat",
        tips_return:"Uusi kuva",
        tips_upgrade:"Päivitä",
        tips_yes:"OK",
        delete:"Poistaa",
        download:"Ladata",
        upload_image:"Lataa kuva",
        new_image:"Uusi kuva",
        save_all:"Tallenna kaikki",
        cancel:"Peruutetaan",
        save:"Tallentaa",
        view_comparison:"Katso vertailu",
        hide_comparison:"Piilota vertailu",
        previous:"Edellinen",
        next:"Seuraava",
        continue_download:"Tallenna kuvat vesileimoilla",
        present:"Käytä tähän kuvaan",
        all_wait:"Käytä Kuvia odottamassa",
        all:"Käytä kaikkiin kuviin",
        history:"Historia",
        login:"Kirjaudu sisään",
    },
    tips:{
        please_upgrade:"Nykyinen suunnitelmasi ei tue kuvien lähettämistä tai suurentamista erissä. Päivitä se saadaksesi enemmän etuja.",
        errorlistinfo:"XXX kuvaa on valittu. XXX kuvaa tuetaan, mutta XXX kuvaa ei tueta. Seuraavia kuvia ei tueta:",
        max:"Ylitä kuvan enimmäiskoko 10 Mt!",
        max_size:"Ylitä kuvan sivun enimmäispituus 4096 pikseliä!",
        continue_dispose:"Laadukkaat tuetut kuvat",
        please_multiple:"Valitse suurennus",
        max_multiple:"* Kuvasi suurennetaan enintään 4K-tarkkuuteen (pisin sivu ei ylitä 4096 pikseliä).",
        title:"Nimi",
        reasons:"Syyt",
        upload_type:"Ei tueta",
        used_up:"Ilman vesileimoja tallennettujen HD-kuvien määrä on käytetty loppuun. Päivitä tilisi. Tai voit tallentaa HD-kuvia vesileimoilla.",
        edit_multiple:"Kuvia on ladattu useita. Valitse kuvat, joiden suurennusta haluat muuttaa. Valinnan jälkeen nämä kuvat skaalataan uudelleen uuteen suurennukseen.",
        download_confirm:"Joitakin kuvia käsitellään edelleen. Oletko varma, että tallennat kaikki parannetut kuvat? Kun tallennat saman kuvan toistuvasti, tallennettujen kuvien määrää ei vähennetä uudelleen.",
        waiting_save:"Joitakin kuvia käsitellään edelleen. Tallenna myöhemmin.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD-kuva(t)",
        watermarks:"ilman vesileimoja voidaan ladata tällä hetkellä.",
        view_details:"Tarkemmat tiedot",
        loading:"Ladataan…",
    },
    content:{
        failed:"Epäonnistui",
        completed:"Valmis",
        processing:"Käsittely",
        img_processing:"Käsitellään…",
        img_failed:"Käsittely epäonnistui",
        uploading:"Ladataan",
        img_uploading:"Ladataan…",
        wait_upoading:"Odotetaan latausta…",
        waiting:"Odottaa",
        img_waiting:"Odotetaan…",
        empty:"Tyhjä",
        magnification:"Suurennus:",
        drop:"Tai pudota kuvatiedostosi tähän skaalataksesi ja parantaaksesi! ",
        original:"Alkuperäinen:",
        output:"Lähtö:",
        img_rendering1:"Kuvaasi on paranneltu.",
        img_rendering2:"Työskentelemme korkealaatuisen kuvan renderöimiseksi esikatselua varten, odota...",
        no_watermark:"Tallennuksen jälkeen kuvassa ei ole vesileimaa.",
    },
    banner_msg:"Valitse suunnitelma Image Upscalerille",
    monthly:"KUUKAUSITTAIN",
    lifetime:"ELINIKÄ",
    choose_plan:"Valitse suunnitelmasi kuvien määrän perusteella",
    return_home:"Onnittelut! Olet päivittänyt onnistuneesti. Palaa kotisivulle ja käytä tätä tuotetta.",
    congratulations:"Onnittelut! Olet päivittänyt onnistuneesti. Edut on sidottu sähköpostiosoitteeseen, jonka jätit päivityksen aikana. Käytä rekisteröityä tai sähköpostiosoitteeseen linkitettyä tiliä osoitteeseen ",
    login_benefits:"kirjaudu sisään käyttääksesi etuja",
    no_registered:". Jos et ole rekisteröitynyt tai linkittänyt tiliä sähköpostiosoitteeseen, ole hyvä ja",
    register_account:"käytä sähköpostiosoitetta tilin rekisteröimiseen",
    other_accounts:" tai linkitä tähän sähköpostiosoitteeseen muita tilejä käyttääksesi etuja.",
    btn_close:"Kiinni",
    free:"Vapaa",
    btn_get_started:"Aloittaa",
    // access_to:"Pääsy",
    upscale_images:"Laadukkaat kuvat",
    up_to:"Aikeissa ",
    per_image:" per kuva",
    resolution_of:"resoluutioon asti",
    default_level:"Korkeatasoiset kuvat oletustasolla",
    image_downloads:"2 HD-kuvan latausta ilman vesileimaa",
    unlimited_image:"Rajoittamaton kuvien lataus vesileimalla",
    SHA256_encryption:"SHA256-salaustekniikka",
    mon:"Kuukausittain",
    images:"kuvat",
    high_resolution:" korkean resoluution laadulla",
    tax_incl:" korkean resoluution laadulla",
    image:"kuva",
    secure_checkout:"Turvallinen kassa",
    everything:"Kaikki ilmaiseksi, ja",
    upscaling_levels:"Kaikki skaalaustasot voidaan valita",
    unlimited_image_without:"Rajoittamaton kuvien lataus ilman vesileimaa",
    viewable_editing:"Näkyvä muokkaushistoria on voimassa ",
    days:" päivää",
    high_level:"Korkeatasoinen",
    priority_processing:" ensisijainen käsittely",
    left:"Elinikä",
    resolution:" resoluutio",
    

    "history_will":"Vanhenee jälkeen",
    "history.days":"päivä(t)",
    "history.hours":"tuntia",
    "expired":"Vanhentunut",
    "access_to":"Ilmaisella kokeilulla voit vain",
    "pricing.upload_images":"Lataa kuvia",
    "pricing.under":"alla",
    "pricing.images":"kuvia",
    "pricing.without_watermark":"ilman vesileimaa",
    "pricing.process_images":"Käsittele kuvia jopa",
    "pricing.pixels":"pikseliä",
    "pricing.enjoy_limited":"Nauti rajoitetuista korkealuokkaisista arvosanoista",
    "pricing.download":"ladata",
    "pricing.HD_images":"HD-kuvat ilman vesileimaa",
    "pricing.and_you":"Ja saatat kärsiä",
    "pricing.slow_upscaling":"hidas skaalaus",
    "pricing.lower_priority":"alhaisempi prioriteetti",
    "pricing.without":"ilman vesileimaa",
    "pricing.tax":"Vero sisältyy myyntihintaan ja se lasketaan automaattisesti maasi ja alueesi perusteella. Ostoskorissa näet tarkan verosumman. Lopullinen maksusummasi on sama kuin näytettävä hinta.",
    "pricing.you_can":"Tilauksella voit",
    "pricing.up_to":"Lataa kuvia enintään",
    "pricing.upscale_images":"Laadukkaat kuvat",
    "pricing.no_watermark":"ei vesileimaa",
    "pricing.enhance":"Parantaa",
    "pricing.or_more":"kuvia tai enemmän",
    "pricing.in_batch":"erässä",
    "pricing.enlarge_images":"Suurenna kuvat sisään",
    "pricing.and":"ja",
    "pricing.times_with":"kertaa ilman rajoituksia",
    "pricing.enjoy":"Nauttia",
    "pricing.of_history":"historian säilytysajasta",
    "pricing.experience":"Kokea",
    "pricing.fast_upscaling":"nopea skaalaus",
    "pricing.higher_priority":"korkeampi prioriteetti",
    "pricing.early_access":"Varhainen pääsy uusiin ominaisuuksiin",
    "pricing.cancel_anytime":"Peru milloin tahansa",
    "pricing.lifetime_license":"Elinikäisellä lisenssillä voit",
    "pricing.and_there":"Ja tulee olemaan",
    "pricing.no_expiration":"ei viimeistä käyttöpäivää",
    "pricing.unless":"ellet lopu loppuun",

    "buynow.pop.credit":"luotto",
    "buynow.pop.credits":"krediittejä",

    "isUnderequityTip_msg1":"Olet valinnut {%} kuvaa eräkäsittelyyn, eikä etuja ole tarpeeksi jäljellä. Tarvitset vielä {%} saldoa (tällä hetkellä {%} saldoa jäljellä). Jos sinun on käsiteltävä, osta etuja jatkaaksesi kuvien käsittelyä.",
    "isUnderequityTip_msg2":"Olet valinnut {%} kuvaa eräkäsittelyyn, eikä etuja ole tarpeeksi jäljellä, Tarvitset vielä {%} saldoa (tällä hetkellä on jäljellä {%} kuvaa eduista). Jos haluat käsitellä, osta etuja jatkaaksesi kuvien käsittelyä.",
    "isUnderequityTip_msg3":"Olet valinnut {%} kuvaa eräkäsittelyyn, eikä etuja ole tarpeeksi jäljellä, Tarvitset vielä {%} saldoa (tällä hetkellä {%} saldoa jäljellä, {%} kuvaa eduista), jos tarvitset prosessi, osta etuja jatkaaksesi kuvien käsittelyä.",
    "btn_buy_now":"Osta nyt",
    "isEquityDepletionTip_msg":"Nykyiset etusi on käytetty. Osta etuja eräkäsittelyyn.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Suunnitelmat ja hinnat",
    "pricing.banner_content":"Hanki AI Photo Editorin krediittejä kuvien taustojen poistamiseen, kuvien skaalaamiseen ja kohteiden poistamiseen kuvista verkossa tai työpöydältä.",
    "pricing.best_seller":"Myydyin",
    "pricing.monthly":"Kuukausitilaus",
    "pricing.credits":"krediittiä",
    "pricing.lifetime":"Elinikäinen",
    "pricing.note":"Huomautus",
    "pricing.buy_now":"Osta nyt",
    "pricing.note_content":"Ostetut krediitit on linkitetty ostoskoriin syöttämääsi sähköpostiosoitteeseen. Käyttääksesi näitä krediittejä rekisteröidy tai kirjaudu sisään samalla sähköpostiosoitteella.",

    "header.buy_more":"Osta lisää",
    "header.available_credits":"Käytettävissä olevat krediitit",
    "header.credits":"krediitti(ä)"
}